import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid p-fluid" }
const _hoisted_2 = { class: "col-12 lg:col-6" }
const _hoisted_3 = { class: "card flex flex-column align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_PropertyDashboard = _resolveComponent("PropertyDashboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-12 lg:col-6 flex align-items-auto" }, [
        _createElementVNode("div", { class: "card w-100pc" }, [
          _createElementVNode("h2", null, "Dashboard"),
          _createElementVNode("div", { class: "css-image compass-logo flex flex-column dashboard-logo" })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.selectedService.serviceName), 1),
          _createVNode(_component_Chart, {
            type: "doughnut",
            data: _ctx.doughnutData,
            options: _ctx.doughnutOptions,
            style: {"width":"50%","max-width":"300px"}
          }, null, 8, ["data", "options"])
        ])
      ])
    ]),
    _createVNode(_component_PropertyDashboard, {
      ref: "propertyDashboardComponent",
      onUpdateOverdue: _cache[0] || (_cache[0] = ($event: any) => {_ctx.overdue = $event;}),
      onUpdateUpcoming: _cache[1] || (_cache[1] = ($event: any) => {_ctx.upcoming = $event;}),
      onUpdateAway: _cache[2] || (_cache[2] = ($event: any) => {_ctx.away = $event;}),
      onUpdateCompleted: _cache[3] || (_cache[3] = ($event: any) => {_ctx.completed = $event;}),
      onUpdateSelectedService: _cache[4] || (_cache[4] = ($event: any) => {_ctx.selectedService = $event;})
    }, null, 512)
  ], 64))
}